import React, { useMemo, useState } from "react";
import * as S from "./UserGeneralNote.style";
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../../florenzComponents/florenzButton";
import FlorenzTextArea from "../../../../../florenzComponents/florenzTextArea";
import Popup from "reactjs-popup";
import { useMutation, useQuery } from "@apollo/client";
import useDoctorData from "../../../../../../hooks/useDoctorData";
import { QUERY_GET_USER_TO_PROCESS_HISTORY_GENERAL_NOTE } from "../../../../../../graphql/queries/UserToProcessHistory";
import { MUTATION_INSERT_USER_TO_PROCESS_HISTORY_GENERAL_NOTE, MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_GENERAL_NOTE } from "../../../../../../graphql/mutations/UserToProcessHistory";
import * as P from "../../../../../../utils/pipes";
import ZaiaReaction from "../../../../../zaiaComponents/zaiaReaction";
import useRecordNavigation from "../../../../../../hooks/useRecordNavigation";
import { Actions } from "../../../../../../utils/actionsIds";

const aiOutcomes = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaDecorators/ai-modal-background.svg`;
const florenceSpeechBubble = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-chat-bubble.svg`;
const zaiaImgLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

function UserGeneralNote({
  patient
}) {

  
  const {t, i18n: { language }} = useTranslation("global");
  const [noteEdition, setNoteEdition] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  const { recordAction } = useRecordNavigation();
  const {data: generalNote, loading: generalNoteLoading, error: generalNoteError, refetch: refetchGeneralNote} = useQuery(QUERY_GET_USER_TO_PROCESS_HISTORY_GENERAL_NOTE, {
    variables: {
      patientId: patient?.id
    },
  });     
  const {doctorData} = useDoctorData();  

  const [insertUserProcessHistoryGeneralNote, {loading: insertLoading}] = useMutation(
    MUTATION_INSERT_USER_TO_PROCESS_HISTORY_GENERAL_NOTE
  );

  const [updateUserProcessHistoryGeneralNote, {loading: updateLoading}] = useMutation(
    MUTATION_UPDATE_USER_TO_PROCESS_HISTORY_GENERAL_NOTE
  );
  

  const handleSubmit = async () => {
    if(generalNote?.userToProcessHistory.length > 0) {
      try {
        // eslint-disable-next-line no-unused-vars
          await updateUserProcessHistoryGeneralNote({
            variables: {
              userToProcessHistoryId: generalNote.userToProcessHistory[0].id,
              doctorId: doctorData.id,
              descript: displayValue
            },
          });
          recordAction(Actions.AINAVIGATOR_MODAL.GENERAL_NOTE_EDITION);
          refetchGeneralNote();
          setNoteEdition(false);
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        // eslint-disable-next-line no-unused-vars
          await insertUserProcessHistoryGeneralNote({
            variables: {
              stageId: patient?.userToProcesses[0].stageId,
              processId: patient?.userToProcesses[0].process.id,
              userToProcessId: patient?.userToProcesses[0].id,
              doctorId: doctorData.id,
              descript: displayValue
            },
          });
          refetchGeneralNote();
          setNoteEdition(false);
      } catch (err) {
        console.log(err);
      }
    }
  }
  

  const changeOptionItem = (value) => {
    setDisplayValue(value);
  }

  // const handleKeyUp = (e, msg) => {
  //   if(e.target.scrollHeight !== 100) {
  //     e.target.style.height = 'inherit';
  //     e.target.style.height = `${e.target.scrollHeight}px`; 
  //   }
  //   if(msg === ""){
  //     e.target.style.height = '100px';
  //   }
  // }


  if(insertLoading || updateLoading)
  return (
    <S.UserGeneralNote>
      <div className="container">
        <ZaiaReaction
          widthimg={"100px"}
          zaiaImg={zaiaImgLoading}
          padding={"40px 0"}
        />
      </div>
    </S.UserGeneralNote>
  )


  return (
    <S.UserGeneralNote>
      <div className="container">
        {
          (generalNote?.userToProcessHistory.length === 0 && !noteEdition) &&
          <div className="no-note">
            <div className="no-note__header">
              <div className="no-note__title">
                {t("globally.noGeneralNote")}
              </div>
              <i className="no-note__icon icon icon zaia-document"></i>
            </div>
            <div className="no-note__description">
              {t("globally.relevantClinicalInfo")}
            </div>
            <div className="no-note__button">
              <FlorenzButton
                typeStyle={"secondary"}
                size="s"
                text={t("globally.add")}
                onClick={() => setNoteEdition(true)}
              />
            </div>
          </div>
        }
        {
          generalNote?.userToProcessHistory.length > 0 && !noteEdition &&
          <div className="note">
            <div className="note__header">
              <div className="note__info">
                <div className="note__doctor">
                  {
                    P.drTranslation(generalNote?.userToProcessHistory[0].doctor.gender, language)
                    + " " + generalNote?.userToProcessHistory[0].doctor.name + " " + generalNote?.userToProcessHistory[0].doctor.lastname
                  }
                </div>
                <div className="note__date">
                  {P.longDate(generalNote?.userToProcessHistory[0].created_at, t, language)}
                  {" - " + P.timeIn12format(generalNote?.userToProcessHistory[0].created_at)}
                </div>
              </div>
              <div className="note__options">
                <Popup
                  trigger={
                    <div className="note__option">
                      <i className="note__option-icon icon zaia-icono-dots-horizontal"></i>
                    </div>
                  }
                  keepTooltipInside
                  nested
                  // position={"right bottom"}
                >
                  {
                    close => (
                      <S.CardOptions>
                        <div className="card-option"
                          onClick={() => {
                            setDisplayValue(generalNote?.userToProcessHistory?.[0].descript);
                            recordAction(Actions.AINAVIGATOR_MODAL.ACTIVATE_GENERAL_NOTE_EDITION);
                            setNoteEdition(true);
                            close();
                          }}
                        >
                          <div className="card-option__icon">
                            <i className="icon zaia-icono-editar"/>
                          </div>
                          <div className="card-option__text">
                            {t("globally.edit")}
                          </div>
                        </div>
                        {/* <div className="card-option">
                          <div className="card-option__icon">
                            <i className="icon zaia-i-trash-can"/>
                          </div>
                          <div className="card-option__text">
                            {t("globally.delete")}
                          </div>
                        </div> */}
                        
                        {/* <div className="card-option"
                          onClick={() => {
                            setNoteHistorySelected(null);
                            setHistoryActived(note);
                            close();
                          }}
                        >
                          <div className="card-option__icon">
                            <i className="icon zaia-i-reverse-clocl"/>
                          </div>
                          <div className="card-option__text">
                            {t("globally.history")}
                          </div>
                        </div> */}
        
                      </S.CardOptions>
                    )
                  }
                </Popup>
              </div>
            </div>
            <div className="note__text">
              {generalNote?.userToProcessHistory[0].descript}
            </div>
          </div>
        }
        {
          noteEdition &&
          <div className="note-edition">
            <div className="note-edition__header">
              <div className="note-edition__title">
                {
                  generalNote?.userToProcessHistory.length > 0 
                  ? t("globally.editAddNote")
                  : t("globally.addANote")
                }
              </div>
              <i className="note-edition__icon icon zaia-i-check-1"></i>
            </div>
            <div className="note-edition__text">
              <FlorenzTextArea
                value={displayValue}
                getText={changeOptionItem}
                // onKeyUp={(e) => handleKeyUp(e, displayValue)}
              />
            </div>
            <div className="note-edition__footer">
              <div className="note-edition__button">
                <FlorenzButton
                  typeStyle={"secondary"}
                  size="s"
                  icon="zaia-icono-cerrar"
                  iconSize="10px"
                  widthComplete={true}
                  onClick={() => {
                    setNoteEdition(false);
                    setDisplayValue("");
                    recordAction(Actions.AINAVIGATOR_MODAL.CANCEL_GENERAL_NOTE_EDITION);
                  }}
                />
              </div>
              <div className="note-edition__button">
                <FlorenzButton
                  typeStyle={"success"}
                  size="s"
                  icon="icon zaia-i-check-1"
                  iconSize="11px"
                  widthComplete={true}
                  onClick={() => {
                    handleSubmit();
                  }}
                />  
              </div>
            </div>
          </div>
        }

      </div>

    </S.UserGeneralNote>
  );
}

export default UserGeneralNote;
